import { render, staticRenderFns } from "./CampaignSoleProprietor.vue?vue&type=template&id=42e2c2a6&scoped=true&lang=pug"
import script from "./CampaignSoleProprietor.vue?vue&type=script&lang=js"
export * from "./CampaignSoleProprietor.vue?vue&type=script&lang=js"
import style0 from "./CampaignSoleProprietor.vue?vue&type=style&index=0&id=42e2c2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e2c2a6",
  null
  
)

export default component.exports